export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-300 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                吃瓜黑料爆料
              </span>
            </div>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed mb-4">
              17c吃瓜黑料爆料聚焦明星出轨内幕、娱乐圈丑闻细节，提供八卦事件深度解析与黑料证据整理，追踪最新吃瓜事件时间线。每日更新，永不缺瓜。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-background-800/50 hover:bg-primary-600 text-background-300 hover:text-background-50 rounded-md transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-background-800/50 hover:bg-primary-600 text-background-300 hover:text-background-50 rounded-md transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-background-800/50 hover:bg-primary-600 text-background-300 hover:text-background-50 rounded-md transition-colors cursor-pointer">
                <i className="ri-vidicon-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a></li>
              <li><a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜热度榜</a></li>
              <li><a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">热门专题</h3>
            <ul className="space-y-2.5">
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">2026出轨盘点</a></li>
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">选秀黑幕专题</a></li>
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">明星税务风波</a></li>
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">人设崩塌档案</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <ul className="space-y-2.5">
              <li><span className="text-xs text-background-500">更多合作伙伴即将入驻</span></li>
              <li><span className="text-xs text-background-500">商务合作请邮件联系</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 吃瓜黑料爆料 17c吃瓜黑料爆料. 本站内容仅供娱乐参考，请理性吃瓜。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#hero" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}